// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"AdminPanelsPage_contentWrapper__1ew9s"};